// src/router/index.js
import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login.vue'
import Layout from './home.js'
import whiteList from './routers' // 引入白名单
import Cookies from 'js-cookie'
import Shopindex from '../views/Shopindex.vue'
import Changeshop from '../views/Changeshop.vue'
// import Workcg from '../views/Workcg.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/Shopindex' // 新增重定向
  },
  {
    path: '/Shopindex',
    name: 'Shopindex',
    component: Shopindex
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/Changeshop',
    name: 'Changeshop',
    component: Changeshop
  },

  Layout // 需要登录才能访问的路由（如主页、个人中心等）
]

const router = new VueRouter({
  routes
})

// 获取 token 的方法（根据实际存储方式调整）
function getToken () {
  return Cookies.get('token')
}

// 全局前置守卫
router.beforeEach((to, from, next) => {
  const hasToken = getToken()

  if (hasToken) {
    // 已登录状态下访问登录页 → 重定向到首页（Layout 对应的默认路径，如 '/'）
    if (to.path === '/login') {
      next({ path: '/' })
    } else {
      next() // 正常放行
    }
  } else {
    // 未登录：检查目标路径是否在白名单中
    if (whiteList.includes(to.path)) {
      next() // 在白名单内，直接放行（如登录页、注册页）
    } else {
      // 不在白名单中，强制跳转到登录页，并携带原目标路径方便登录后跳回
      next({ path: '/login', query: { redirect: to.fullPath } })
    }
  }
})

export default router
